import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { NotificationDTO } from 'tekkeys-common';

export interface NotificationsState extends EntityState<NotificationDTO> {}

export const notificationsAdapter: EntityAdapter<NotificationDTO> = createEntityAdapter<NotificationDTO>();
